import {
  definePlatformAPI,
  ApiVersions,
  ConsumerTypes,
  IContext,
  IHostType,
} from '../../common';
import { ISuperAPI } from './accessibility.super';

export type IPlatformAPIDefinition = {
  consumerType: typeof ConsumerTypes.Internal;
  version: typeof ApiVersions.V1;
  hostType: IHostType;
  superAPI: ISuperAPI;
  // NOTE: every method, used as a V1 implementation already receives appData and token as first params
  platformAPI: {
    document: {
      accessibility: {
        getSkipToContent: (appData: IContext, token: any) => Promise<boolean>;
        setSkipToContent: (
          appData: IContext,
          token: any,
          enable: boolean,
        ) => Promise<void>;
        getVisualFocus: (appData: IContext, token: any) => Promise<boolean>;
        setVisualFocus: (
          appData: IContext,
          token: any,
          enable: boolean,
        ) => Promise<void>;
        getAutoDomReorder: (appData: IContext, token: any) => Promise<boolean>;
        setAutoDomReorder: (
          appData: IContext,
          token: any,
          enable: boolean,
        ) => Promise<void>;
      };
    };
    editor: {
      accessibility: {
        getAdvancedSettings: (
          appData: IContext,
          token: any,
        ) => Promise<boolean>;
        setAdvancedSettings: (
          appData: IContext,
          token: any,
          options: { value: boolean },
        ) => Promise<void>;
      };
    };
  };
};

export const platformAPICreator = definePlatformAPI<IPlatformAPIDefinition>(
  (superAPI) => {
    return () => {
      return {
        editor: {
          accessibility: {
            getAdvancedSettings: () =>
              superAPI.accessibility.getAdvancedSettings(),
            setAdvancedSettings: (_appData, _token, options) =>
              superAPI.accessibility.setAdvancedSettings(options.value),
          },
        },
        document: {
          accessibility: {
            getSkipToContent: () => superAPI.accessibility.getSkipToContent(),
            setSkipToContent: (appData, _token, options) =>
              superAPI.accessibility.setSkipToContent(
                appData.appDefinitionId,
                options,
              ),
            getVisualFocus: () => superAPI.accessibility.getVisualFocus(),
            setVisualFocus: (appData, _token, options) =>
              superAPI.accessibility.setVisualFocus(
                appData.appDefinitionId,
                options,
              ),
            getAutoDomReorder: () => superAPI.accessibility.getAutoDomReorder(),
            setAutoDomReorder: (appData, _token, options) =>
              superAPI.accessibility.setAutoDomReorder(
                appData.appDefinitionId,
                options,
              ),
          },
        },
      };
    };
  },
);
